module.exports = __webpack_public_path__ + "img/palmar-room-10.e8eea977.jpg";